import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MultilineTextFilter } from '@models/filter-types';
import { FilterInputErrorStateMatcher } from '@shared/components/filters/filter-input-error-state-matcher';

@Component({
    selector: 'app-multiline-text',
    standalone: false,
    templateUrl: './multiline-text.component.html',
    styleUrl: './multiline-text.component.scss',
})
export class MultilineTextComponent implements OnChanges {
    @Input() appearance?: 'outline' | 'fill';
    @Input() property!: MultilineTextFilter;
    @Input() showErrorsAfterInteraction = false;

    @Output() valueChanged: EventEmitter<unknown> = new EventEmitter<unknown>();
    @Output() keyDownEvent: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

    disabled = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorStateMatcher!: FilterInputErrorStateMatcher<any>;

    ngOnChanges() {
        this.disabled = this.property?.isReadonly;
        this.errorStateMatcher = new FilterInputErrorStateMatcher(this.property, this.showErrorsAfterInteraction);
    }

    onKeyDown(event: KeyboardEvent) {
        this.keyDownEvent.emit(event);
    }
}
